import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";

import OptionIcon from '../../../Image/OptionIcon.png';

export default function EventSalesBox(props) {
  const { event, onClickMove, onClickRefund, onClickDelete } = props;

  const [isClicked, setIsClicked] = useState(false);
  const OptionButtonRef = useRef(null);
  const OptionBoxRef = useRef(null);
  const OptionMoveRef = useRef(null);
  const OptionRefundRef = useRef(null);
  const OptionDeleteRef = useRef(null);

  // 클릭 이벤트 핸들러 등록 및 삭제 //
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 선택옵션 크기 설정 //
  useEffect(() => {
    if (isClicked) {
      OptionBoxRef.current.style.height = `114px`;
      OptionBoxRef.current.style.border = `1px solid #6DD49E`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid #6DD49E`;
    }
  }, [isClicked])

  // 컴포넌트 외부 클릭시 옵션칸 닫기 
  function onClickOutSide(e) {
    if (OptionBoxRef.current !== e.target
      && OptionButtonRef.current !== e.target
      && OptionMoveRef.current !== e.target
      && OptionRefundRef.current !== e.target
      && OptionDeleteRef.current !== e.target) {
      setIsClicked(false);
    }
  }

  // 부문 변경버튼 클릭시 //
  function onClickMoveButton() {
    onClickMove();
    setIsClicked(false);
  }

  // 환불버튼 클릭시 //
  function onClickRefundButton() {
    onClickRefund();
    setIsClicked(false);
  }

  // 삭제버튼 클릭시 //
  function onClickDeleteButton() {
    onClickDelete();
    setIsClicked(false);
  }

  return (
    <TotalSalesWrapper>
      <SalesColumnWrapper>
        <SalesTextWrapper style={{ marginLeft: '20px' }} width={172}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>신청</Text>
        </SalesTextWrapper>
        <SalesTextWrapper width={102}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>선택 옵션</Text>
        </SalesTextWrapper>
        <SalesTextWrapper width={122}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>신청 일자</Text>
        </SalesTextWrapper>
        <SalesTextWrapper width={82}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>결제 금액</Text>
        </SalesTextWrapper>
        <SalesTextWrapper width={172}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>카드</Text>
        </SalesTextWrapper>
      </SalesColumnWrapper>

      <SalesInfoBox isRefund={event.refundId !== undefined}>
        <SalesTextWrapper width={172}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{event.eventTitle}</Text>
        </SalesTextWrapper>
        <SalesTextWrapper width={102}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{event.eventSelectOptionName === '' ? '없음' : event.eventSelectOptionName}</Text>
        </SalesTextWrapper>
        <SalesTextWrapper width={122}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{event.approvalDate}</Text>
        </SalesTextWrapper>
        <SalesTextWrapper width={82}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>
            {event.eventPrice.toLocaleString()}
          </Text>
        </SalesTextWrapper>
        <SalesTextWrapper width={472}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>
            {event.totalPrice.toLocaleString()}
          </Text>
        </SalesTextWrapper>
        <OptionBox>
          <OptionViewWrapper ref={OptionButtonRef} onClick={() => setIsClicked(!isClicked)}>
            <OptionView src={OptionIcon} />
          </OptionViewWrapper>
          <OptionWrapper ref={OptionBoxRef}>
            <Option ref={OptionMoveRef} onMouseDown={onClickMoveButton}>수정</Option>
            <Option ref={OptionRefundRef} onMouseDown={onClickRefundButton}>환불</Option>
            <Option ref={OptionDeleteRef} onMouseDown={onClickDeleteButton}>삭제</Option>
          </OptionWrapper>
        </OptionBox>
      </SalesInfoBox>
      {
        event.refundId !== undefined &&
        <RefundBoxWrapper>
          <RefundBox>
            <SalesTextWrapper width={90}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>환불 완료</Text>
            </SalesTextWrapper>
            <SalesTextWrapper width={128}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{event.approvalDate}</Text>
            </SalesTextWrapper>
            <SalesTextWrapper width={122}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{'카드 - ' + event.totalPrice.toLocaleString()}</Text>
            </SalesTextWrapper>
          </RefundBox>
        </RefundBoxWrapper>
      }
    </TotalSalesWrapper>
  )
}

const TotalSalesWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const SalesColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-top: 24px;

  width: 100%;

  gap: 8px;
`;

const SalesInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 20px;
  margin-top: 24px;
  
  width: calc(100% - 40px);
  height: 52px;

  gap: 8px;

  border-top-left-radius: 30px;
  border-top-right-radius: ${props => props.isRefund ? `20px` : `30px`};
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: ${props => props.isRefund ? `0px` : `30px`};

  background-color: #2F2F32;

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const RefundBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  width: 100%;
  height: 52px;
`;

const RefundBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 20px;

  width: calc(81% - 40px);
  height: 100%;

  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: #D92828;

  :hover {
    cursor: pointer;
  }
`;

const SalesTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 21px;

  overflow: hidden;
`;

const OptionBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  width: 24px;
  height: 24px;

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const OptionViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  width: 100%;
  height: 100%;

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const OptionView = styled.img`
  width: 21px;
  height: 18px;
`;

const OptionWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  margin-top: 40px;

  border-radius: 8px;
  background-color: #2F2F32;

  overflow: hidden;
    
  z-index: 10;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;;

  justify-content: center;
  align-items: center;

  width: 58px;
  height: 38px;

  margin: 0 0 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #6DD49E;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color: #6DD49E;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;